import { call, put, select, takeLatest } from 'redux-saga/effects';
import { RETREAT } from './constants';
import { waitForUndo } from '../Undo/waitForUndo';
import { retreatWaits } from '../Undo/undoableMoves';
import { undoDone } from '../Undo/actions';
import { swapWords } from '../Undo/swapWords';
import { retreatDone } from './actions';
import { retreat } from '../services/game';
import { handleUpdateGame } from '../ActiveGame/sagas';
import { closeContextMenu } from '../ActiveGame/actions';
import { selectActiveGame, selectActivePokemon, selectBench } from '../ActiveGame/selectors';
import { selectCurrentUser } from '../Login/selectors';
import { selectEnergyAttachmentIds, selectBenchPosition } from './selectors';

// A retreat waits with an Undo before it's sent (Undo/undoableMoves).
function* retreatTask() {
  const gameId = (yield select(selectActiveGame)).get('id');
  const energyAttachmentIds = yield select(selectEnergyAttachmentIds);
  const benchPosition = yield select(selectBenchPosition);

  try {
    const userId = (yield select(selectCurrentUser)).get('id');
    const active = yield select(selectActivePokemon, { userId });
    const bench = yield select(selectBench, { userId });
    // The Pokémon's sheet closes first, so the board shows the swap while you can still undo it.
    yield put(closeContextMenu());
    if (yield call(waitForUndo, retreatWaits(), swapWords(active, bench, benchPosition), { swap: { userId, benchPosition } })) {
      return;
    }
    const game = yield call(retreat, gameId, benchPosition, energyAttachmentIds);
    yield call(handleUpdateGame, game);
    yield put(closeContextMenu());
  } finally {
    // A refused retreat still ends the flow, so the board is not left waiting for a choice.
    yield put(undoDone());
    yield put(retreatDone());
  }
}

function* retreatWatcher() {
  yield takeLatest(RETREAT, retreatTask);
}

export default [
  retreatWatcher,
];
